import React from 'react';
import PropTypes from 'prop-types';
import { TableBody, TableCell, TableRow } from '@mui/material';

export default function TableContent({
  page,
  rows,
  rowsPerPage,
  columns,
  setOpenModal,
  fetchSingleProduct,
}) {
  const handleOpenModal = (row) => {
    setOpenModal('adminSingleProduct', true);
    fetchSingleProduct(row.id);
  };

  return (
    <TableBody>
      {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
        <TableRow
          hover
          role="checkbox"
          tabIndex={-1}
          key={row.id}
          onClick={() => handleOpenModal(row)}
        >
          {columns.map((column) => {
            const value = row[column.id];
            return (
              <TableCell
                key={column.id}
                align={column.align}
              >
                {column.format && typeof value === 'number' ? column.format(value) : value}
              </TableCell>
            );
          })}
        </TableRow>
      ))}
    </TableBody>
  );
}

TableContent.propTypes = {
  page: PropTypes.number.isRequired,
  columns: PropTypes.arrayOf(PropTypes.any).isRequired,
  rows: PropTypes.arrayOf(PropTypes.any).isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  setOpenModal: PropTypes.func.isRequired,
  fetchSingleProduct: PropTypes.func.isRequired,
};
